import { Place } from '@/types/state/shared';

type State = {
  place: Place;
  loading: boolean;
  is404: boolean;
};

type Action =
  | {
      type: 'SET_PLACE';
      payload: Place;
    }
  | {
      type: 'SET_LOADING';
      payload: boolean;
    }
  | {
      type: 'SET_IS_404';
    };

export default function placeReducer(state: State, action: Action) {
  switch (action.type) {
    case 'SET_PLACE':
      return {
        ...state,
        place: action.payload,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_IS_404':
      return {
        ...state,
        is404: true,
      };
    default:
      return state;
  }
}
